import React, { FC, Fragment, useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { format, ddayjs, classNames } from '@dt/fe-utils'
import { groupBy, map, each, maxBy, minBy } from '@dt/fe-utils/dist/lodash'
import { useHistoryNew } from '@utils'
import { OrderProductImg } from '@cps'
import { orderMobx } from 'restaurant'
import { memberMobx } from '@mobxStore'
import { RestoreOrderController, OrdersController } from '@ctrls/index'
import OrderBuyAgainBtn from './OrderBuyAgainBtn'
import { TEOrderStatus, TEOrdersRefundStatus, TEOrdersType } from '@common/enum/order.enum'
import { refundMobx } from '@mobx/order'
import OrderRefundBtn from './OrderRefundBtn'
import OrderCommentBtn from './OrderCommentBtn'

const _getTimeText = (startTime: string, pickTimeRange: string) => {
  const index = Number(ddayjs(startTime).format('YYYYMMDD') || '') - Number(ddayjs().format('YYYYMMDD') || '')
  const date = index >= 1 ? `${format.toDate(startTime)} ` : ''
  if (pickTimeRange) {
    try {
      const pickTimeRangeObj = JSON.parse(pickTimeRange) || {}
      if (pickTimeRangeObj?.start) {
        const start = ddayjs(pickTimeRangeObj.start).valueOf()
        const end = ddayjs(pickTimeRangeObj.end).valueOf()
        return date || `${format.toTime(start)}-${format.toTime(end)}`
      }
    } catch (error) {
    }
  }
  return `${date}${format.toTime(ddayjs(startTime).valueOf())}`
}
const OrderItem = (props: any) => {
  const history = useHistoryNew()
  const { info, couponMap, showBA } = props
  const [statusGroups, setStatusGroups] = useState<{
    key: string;
    imgs: string[];
    cnt: number;
    price: number;
    startTime: string;
    timeStr: string;
    productsStr: string;
    currentStatusIndex: number;
  }[]>([])
  const { refundConfig: { eatType: eatTypes } } = refundMobx
  const refundInfo = info.ordersRefundList?.[info.ordersRefundList?.length - 1]
  /** 是否可以再来一 */
  const chackCanBuyAgain = useMemo(() => {
    if (showBA && ['dc'].includes(info.ordersType) && info.status === 'Success') {
      if (Config.codeType === 'brand' && (info.tableCode || info.tableAlias || info.tableTent)) {
        return false
      }
      return true
    }
    return false
  }, [info])
  /** 是否可展示退款状态 */
  const showRefundStatus = useMemo(() => {
    /** TODO 231212 周厨确认手机发起的没有deviceId，可以从deviceId === null 判断是手机 */
    return info.ordersType === TEOrdersType.dc && info.refundTime && refundInfo && eatTypes.includes(info.eatType) && Object.values(TEOrdersRefundStatus).includes(refundInfo.status) && refundInfo?.deviceId === null
  }, [info, eatTypes])
  useEffect(() => {
    if (info.ordersType === 'dc' || info.ordersType === 'mall') {
      getStatusGroups()
    }
  }, [info])

  const getProductStatus = (group) => {
    let { eatType, statusShowName, time, ordersType, payMode, status } = info
    const { currentStatusIndex = 0, startTime = '' } = group
    const currentIndex = currentStatusIndex > statusShowName?.length - 1 ? statusShowName?.length - 1 : currentStatusIndex
    const isLastIndex = currentIndex === statusShowName?.length - 1
    let isRed = ['sending'].includes(statusShowName[currentIndex])
    const statusTxt = ordersType === 'mall' ? 'result.expressStatusNew' : 'result.makeStatus'
    let statusNode = <div className={classNames('status-wrap', { red: isRed })}>{i18n.t(`${statusTxt}.${statusShowName[currentIndex]}`)}</div>
    let timeNode = <></>
    if (['Cancel', 'Timeout', 'Paying'].includes(status) || payMode === 1) { // 订单超时 取消，或者后付费直接展示订单状态
      statusNode = <div className='status-wrap'>{i18n.t(OrdersController.OrderStatusMap[status])}</div>
    } else if (refundInfo?.status === TEOrdersRefundStatus.Success && group.refundCnt > 0) {
      statusNode = <div className='status-wrap'>{i18n.t(`result.refund${group.refundCnt >= group.cnt ? 'All' : 'Part'}${ordersType === 'mall' ? 'Mall' : ''}`)}</div>
    } else if (eatType !== 'delivery') {
      if (!info.kdsInfo) {
        statusNode = <div className='status-wrap'>{i18n.t('result.paySuccess')}</div>
        timeNode = ordersType === 'dc' && group?.timeStr && (ddayjs('2022-06-09 17:10:11').valueOf() < ddayjs(group?.startTime).valueOf()) && <div className='time-wrap'>{i18n.t(`result.${eatType === 'dinein' ? 'dineinStatusTime' : 'pickupStatusTime'}`, { time: group?.timeStr })}</div>
      } else if (statusShowName?.length > 2 || (time === startTime) ? isLastIndex : ddayjs(startTime).valueOf() <= ddayjs().valueOf()) {
        statusNode = <div className='status-wrap'>{statusShowName?.length > 2 ? i18n.t('result.finish') : i18n.t('result.paySuccess')}</div>
      } else {
        timeNode = time !== startTime && <div className='time-wrap'>{i18n.t(`result.${eatType === 'dinein' ? 'dineinStatusTime' : 'pickupStatusTime'}`, { time: group?.timeStr })}</div>
      }
    } else {
      if (isLastIndex) {
        // statusNode = <div className='status-wrap'>{i18n.t('result.finish')}</div>
      } else {
        timeNode = time !== startTime && <div className='time-wrap'>{i18n.t('result.deliveryStatusTime', { time: group?.timeStr })}</div>
      }
    }
    return (
      <div className='order-item-status-right'>
        {statusNode}
        {timeNode}
      </div>
    )
  }

  const getStatusGroups = () => {
    let groups = []
    const detailList = info.detailList.filter(d => d?.itemType !== 'express')
    each(groupBy(detailList, d => d?.pickTimeRange || d?.startTime), (items: any[], key: string) => {
      const startTime = items?.[0]?.startTime
      const pickTimeRange = key && startTime && key !== startTime ? key : ''
      const imgs = []
      let cnt = 0
      let price = 0
      let texts = []
      let refundCnt = 0
      each(items, (item) => {
        const index = info?.picsProduct.findIndex((productNo) => productNo === item.productNo) || 0
        if (['product', 'mallProduct'].includes(item.itemType)) {
          imgs.push(info.imgs[index])
          texts.push(item.productName)
          cnt += item.cnt
        }
        // 套餐子餐品不计算价格
        if (!(['product'].includes(item.itemType) && item.parentId !== '0')) {
          price += item.paidFee + item.tax
        }
        refundCnt += item.refundCnt
      })
      // 过滤没有餐品的组
      cnt > 0 && groups.push({
        key,
        products: items,
        imgs,
        cnt,
        price,
        refundCnt,
        startTime: startTime,
        timeStr: _getTimeText(startTime, pickTimeRange),
        productsStr: texts.join(','),
        currentStatusIndex: minBy(items.filter(item => item.itemType === 'product'), 'currentStatusIndex')?.currentStatusIndex || 0,
      })
    })
    groups = groups.sort((a, b) => ddayjs(a.startTime).valueOf() - ddayjs(b.startTime).valueOf())
    setStatusGroups(groups)
  }

  /** 判断当前订单能否去结算页，不同channel下单的需要做限制 */
  const checkCanToCart = (info) => {
    switch (Config.codeType) {
      case 'brand':
        return ['mobile', 'selfDelivery'].includes(info.channel)
      case 'store':
      case 'table':
        return ['mobile'].includes(info.channel)
      default:
        return false
    }
  }

  const GotoDetail = () => {
    const { status } = info
    // 订单是否需要切换桌码模式，品牌码下点击桌码订单的场景
    const isTableOrder = !!(info?.tableCode && ['Pending', 'NotAccepted'].includes(status) && Config.codeType !== 'table')
    if (isTableOrder) {
      window.location.href = `${window.location.origin}/checkout?ct=table&b=${Config.BRANDID}&s=${info.storeId}&t=${info.tableCode}`
    } else {
      if (status === 'Pending' || status === 'NotAccepted') {
        // 需要更改这笔等待
        if (checkCanToCart(info)) {
          orderMobx.init(info.ordersId).then(() => {
            RestoreOrderController.checkout()
          })
          return
        }
      }
      let pathname = `/result/${info.ordersId}`
      history.push({
        pathname,
        state: {
          fromList: true
        }
      })
    }
  }

  const OrderHeaderNode: FC = () => {
    const refundTag = (refundInfo?.status === TEOrdersRefundStatus.Success && !!info.refundTime) && <div className='tag refund-tag'>{i18n.t('result.refundTag')}</div>
    const btTag = [info.channel, info.sourceType].includes('buyTogether') && <div className='tag bt-tag'>拼</div>
    switch (info.ordersType) {
      case 'mall':
        return <span className='order-channel'>{format.toDateTime(info.time)} {refundTag}</span>
      default:
        return (
          <Fragment key={info.ordersId}>
            <span className='order-channel'>
              #{info.nono || i18n.t('order.notAccepted')} {i18n.t(OrdersController.OrderEatType[info.eatType]) || ''} {info.tableAlias && `${i18n.t('result.tableAlias')} ${info.tableAlias}`} {info.tableTent && `${i18n.t('result.tableTent')} ${info.tableTent}`} {btTag} {refundTag}
            </span>
            <span className='order-times'>{format.toDateTime(info.time)} {['dc'].includes(info.ordersType) && info.storeName}</span>
          </Fragment>
        )
    }
  }
  const OrderHeaderRightNode: FC = () => {
    return (
      <Fragment key={info.ordersId + 'header-right'}>
        {!!showRefundStatus && <span className={classNames('refund-txt', { error: [TEOrdersRefundStatus.Timeout, TEOrdersRefundStatus.Reject].includes(refundInfo.status) })}>{i18n.t(`refund.status.${refundInfo.status}`)}</span>}
      </Fragment>
    )
  }
  const isGiftCard = info.eatType === 'giftcard' || info.eatType === 'giftcardCz'
  return info && (
    <div className='order-item' onClick={GotoDetail}>
      <div className='order-item-header'>
        <div className='order-item-header-left'>
          <OrderHeaderNode />
        </div>
        <div className='order-item-header-right'>
          <OrderHeaderRightNode />
        </div>
      </div>
      {
        statusGroups?.map((item: any, index: number) => {
          // 是否可以评论
          const canComment = ['dc'].includes(info.ordersType) && index === statusGroups.length - 1 && info.status === 'Success' && memberMobx.brandConfig.commentSetting && memberMobx.brandConfig.commentSetting.enable
          // 是否可以再来一单
          const showBuyAgain = chackCanBuyAgain && index === statusGroups.length - 1 // && !cartMobx.ordersId
          /**
           *  todo debug eatTypes
           */
          const canRefund = ['dc'].includes(info.ordersType) && index === statusGroups.length - 1 && info.status === TEOrderStatus.Success && !info.refundTime && eatTypes.includes(info.eatType) && (statusGroups[0].startTime && ddayjs(statusGroups[0].startTime).valueOf() > ddayjs().valueOf())
          return (
            <div key={item.key}>
              <div className='circle'><div className='dashed'></div></div>
              <div className='order-item-main'>
                <div className='order-info'>
                  <div className='order-info-content-wrapper'>
                    <div className='order-img-list'>
                      {
                        item.imgs?.slice(0, 3).map((item, index) => {
                          return (
                            <div className='order-img' key={index}>
                              <OrderProductImg key={index} imgSrc={item} width={48} />
                            </div>
                          )
                        })
                      }
                      {item.imgs?.length > 3 && <div className='orderlist-image-more'>...</div>}
                    </div>
                    {getProductStatus(item)}
                  </div>
                  <div className='order-count-info-wrapper'>
                    <div className='order-count-info-left-wrap'>
                      <div className='order-count-info'>
                        <span>{i18n.t('order.count', { cnt: item.cnt })}</span>
                        <span>{format.toPrice(item.price)}</span>
                      </div>
                      <div className='order-product-name'>
                        <div className='name-str'>
                          <span>{item.productsStr}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {
                (canComment || showBuyAgain || canRefund) && (
                  <div className='order-other-btn-wrap'>
                    <div className='left-wrap'>
                      {canRefund && <OrderRefundBtn info={info} />}
                    </div>
                    <div className='right-wrap'>
                      {canComment && <OrderCommentBtn info={info} />}
                      {/* 再来一单 */}
                      {showBuyAgain && <OrderBuyAgainBtn info={info} />}
                    </div>
                  </div>
                )
              }
            </div>
          )
        })
      }
      {/* 会员虚拟订单，充值  */}
      {['cz', 'goods'].includes(info.ordersType) && (
        <>
          <div className='circle'><div className='dashed'></div></div>
          <div className='order-item-main'>
            <div className='order-info'>
              <div className='order-info-content-wrapper'>
                <div className='order-img-list'>
                  {
                    (info.eatType !== 'redeemCouponByMoney' && info.imgs?.length > 0 || info.eatType === 'redeemCouponByMoney' && Object.keys(couponMap).length > 0) && info.imgs?.slice(0, 3).map((item, index) => {
                      const newItem = (info.eatType === 'redeemCouponByMoney') ? couponMap[item.couponId]?.picture : item
                      return (
                        <div className='order-img' key={index}>
                          <OrderProductImg key={index} imgSrc={newItem} width={48} />
                        </div>
                      )
                    })
                  }
                  {info.imgs?.length > 3 && <div className='orderlist-image-more'>...</div>}
                  {info.cardNo && <span>{info.productName || info.cardType} {!isGiftCard ? info.cardNo : ''}</span>}
                </div>
                <div className='order-item-status-right'>
                  <div className='status-wrap'>{i18n.t(OrdersController.OrderStatusMap[info.status])}</div>
                </div>
              </div>
              <div className='order-count-info-wrapper'>
                <div className='order-count-info-left-wrap'>
                  <div className='order-count-info'>
                    <span>{i18n.t('order.count', { cnt: info.cnt })}</span>
                    <span>{format.toPrice(info.price)}</span>
                  </div>
                  {!isGiftCard && (
                    <div className='order-product-name'>
                      <div className='name-str'>
                        <span>{info.eatType === 'redeemCouponByMoney' && Object.keys(couponMap).length > 0 && info.imgs ? map(info.imgs, item => `${couponMap[item.couponId] ? couponMap[item.couponId].couponName : ''}x${item.couponCnt}`).join(', ') : info.desc}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {['goods'].includes(info.ordersType) && info?.cnt > 1 && (
            <div className='order-item-footer'>
              <div className='order-stores'>...</div>
            </div>
          )}
        </>
      )}
      {
        info.ordersType === TEOrdersType.dc && info.memberOrder && info.memberOrder.memberType && info.memberOrder.memberType !== 'member' && (
          <div className='order-item-tip'>
            <span>{i18n.t('order.notMemberTip')}</span>
          </div>
        )
      }
    </div>
  )
}
export default observer(OrderItem)
